<template>
  <div>
    <div class="right-title">
      <span>站内信详情</span>
      <el-button plain class="go-back" @click="goBack">返回</el-button>
    </div>
    <div class="content-box">
      <div class="jieshou-box">
        <span class="list">{{formList}}</span>
      </div>
      <div class="shenhe-btn" >
        <el-button v-if="(jobs_user_states===2||jobs_user_states===3)&& jobs_user_states_now === 2" class="conter-btn" type="success" @click="shenhe(1)">同意</el-button>
        <el-button v-if="(jobs_user_states===2||jobs_user_states===3)&& jobs_user_states_now === 2" class="conter-btn" type="danger" @click="shenhe(2)">拒绝</el-button>
        <el-button class="conter-btn" v-if="(jobs_user_states===1||jobs_user_states===2||jobs_user_states===3)&&jobs_user_states_now !== 2">{{jobs_user_states_now | state}}</el-button>
<!--        <el-button class="conter-btn" type="primary" @click="toZhiwei">查看职位</el-button>-->
      </div>
      <h3 class="title">{{title}}</h3>
      <p class="time">{{create_time}}</p>
      <div class="edit-contents ql-editor" v-html="content"></div>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "znxDetail",
    data() {
      return {
        title: '',
        create_time: '',
        content: '',
        formList: '',
        jobs_id:'',
        jobs_user_id: '',
        jobs_user_states: 0,  // 是否显示同意拒绝按钮（推荐邀请面试）
        jobs_user_states_now:'',
        uid:''    // 推荐邀请面试操作需要的id
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.uid = this.$route.query.uid
      this.$emit('setType', 1)
      this.init()
    },
    methods: {
      //  去职位
      toZhiwei(){
        window.open("http://zxwpc.emof.net/home/jobDetails/"+this.jobs_id+'?state='+this.jobs_user_states_now+'&passId='+this.jobs_user_id+'&tyeps='+this.jobs_user_states+'&adminId='+this.user.id,"_blank");
        // this.$router.push('/home/jobDetails4/zwDetail/'+this.jobs_user_id)
      },
      init() {
        this.$api.apiContent.myGetZneDetail({
          adminId: this.user.id,
          id: this.$route.params.id
        }).then(res => {
          this.title = res.data.showData.title
          this.content = res.data.showData.content
          this.create_time = this.$tools.ZHDate(new Date(res.data.showData.create_time * 1000),6)
          this.jobs_user_id = res.data.showData.jobs_user_id
          this.jobs_user_states = res.data.showData.jobs_user_states
          this.jobs_user_states_now = res.data.showData.jobs_user_states_now
        }).catch()
      },

      //  面试邀请 同意 拒绝
      shenhe(state) {      //  1 通过 2 拒绝
        if (state === 1) {
          this.$api.apiContent.znxChiocePass({
            adminId: this.user.id,
            insideLettersId: this.$route.params.id,
            jobsUserId: this.jobs_user_id,
            choose: 1
          }).then((res) => {
            this.$message.success(res.info)
            this.init()
          }).catch(e => {
            this.$message.error(e.info)
          })
        } else {
          this.$confirm('您确定要拒绝吗', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$api.apiContent.znxChiocePass({
              adminId: this.user.id,
              insideLettersId: this.$route.params.id,
              jobsUserId: this.jobs_user_id,
              choose: 2
            }).then((res) => {
              this.$message.success(res.info)
              this.init()
            }).catch(e => {
              this.$message.error(e.info)
            })
          }).catch()
        }
      },


      goBack() {     //  返回上一页
        this.$tools.goBack()
      },
    },
    filters: {
      state(val) {
        console.log(val)
        let num = !val?0 : Number(val)
        switch (num) {
          case 0:
            return '已拒绝'
          case 1:
            return '处理中'
          case 2:
            return '面试邀请'
          case 3:
            return '拒绝'
          case 4:
            return '被搁置'
          case 5:
            return '已同意'
          case 6:
            return '已同意'
          case 7:
            return '已同意'
          case 8:
            return '已拒绝'
          case 9:
            return '已同意'
        }
      },
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .jieshou-box {
    line-height: 40px;
    display: flex;
    justify-content: flex-start;

    .list {
      flex: 1;
    }

    .name {
      width: 100px;
    }
  }

  .title {
    line-height: 48px;
    font-size: 24px;
    text-align: center;
    font-weight: 500;
    margin-bottom: 10px;
  }

  .time {
    text-align: center;
  }

  .edit-contents {
    padding: 10px;

  }
</style>